import { render } from "./Grid.vue?vue&type=template&id=6e463970&scoped=true"
import script from "./Grid.vue?vue&type=script&setup=true&lang=js"
export * from "./Grid.vue?vue&type=script&setup=true&lang=js"

import "./Grid.vue?vue&type=style&index=0&id=6e463970&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e463970"],['__file',"src/components/Wishlist/Grid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e463970"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e463970', __exports__)) {
    api.reload('6e463970', __exports__)
  }
  
  module.hot.accept("./Grid.vue?vue&type=template&id=6e463970&scoped=true", () => {
    api.rerender('6e463970', render)
  })

}


export default __exports__